<template>
  <div>
    <v-navigation-drawer  style="position:sticky; top:0px ; right:0px" permanent color="primary" dark height="100vh" width="20vw">
      <v-list shaped color="primary">
        <v-list-item-group color="secondary">
          <v-list-item to="/home">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>خانه </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/users">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>کاربران </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/companies">
            <v-list-item-icon>
              <v-icon>mdi-bag-checked</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>شرکت ها </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/products">
            <v-list-item-icon>
              <v-icon>mdi-package-variant-closed</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> کالا/خدمات </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- pay gorup -->
          <v-list-group no-action  color="secondary">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>mdi-cash</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>مالی</v-list-item-title>
              </v-list-item-content>
            </template>
  
            <v-list-item to="/payments">
              <v-list-item-icon>
                <v-icon>mdi-credit-card-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle> پرداخت ها </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
  
  
            <v-list-item to="/pay_type">
              <v-list-item-icon>
                <v-icon>mdi-wallet</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle> نوع پرداخت </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item @click="logout()">
             <v-list-item-icon>
               <v-icon>mdi-logout</v-icon>
             </v-list-item-icon>
  
             <v-list-item-content>
               <v-list-item-title> خروج </v-list-item-title>
             </v-list-item-content>
           </v-list-item>

        </v-list-item-group>


      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          action: "mdi-silverware-fork-knife",
          active: true,
         
          title: "Dining",
        },
        {
          action: "mdi-school",
          items: [{ title: "List Item" }],
          title: "Education",
        },
      ],
    };
  },

  methods: {
    logout(){
      sessionStorage.clear()
      this.$router.push('/login')
    }
  }
};
</script>

<style>
#side-nav {
  font-size: 13px !important;
}
.v-list-item-title {
  font-size: 0.9rem;
}
</style>